export class Direction {
  static NONE = '';

  static HOR = 'horizental';

  static VER = 'vertical';
}
